import { useTranslations } from 'next-intl';
import { Alert } from '@//components/Alert';
import styles from '../GalleryModal.module.scss';
import type { GalleryEmbedded } from '../utils';

const getYouTubeId = (url: string): string => {
  const match = url.match(
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([A-Za-z0-9_-]{11})/,
  );
  return match ? match[1] : '';
};

interface GalleryModalVideoYoutubeProps {
  video: GalleryEmbedded;
  autoPlay?: boolean;
}

const GalleryModalVideoYoutube: React.FC<GalleryModalVideoYoutubeProps> = ({
  video,
  autoPlay = false,
}) => {
  const t = useTranslations('pages.item.imageGallery.modal');
  const videoId = getYouTubeId(video.url);

  if (!videoId)
    return (
      <Alert id="alert-invalid-youtube-url" variant="critical">
        {t('invalidVideo.youtube')}
      </Alert>
    );

  const src = `https://www.youtube-nocookie.com/embed/${videoId}?enablejsapi=1&rel=0${autoPlay ? '&autoplay=1' : ''}`;

  const iframe = (
    <iframe
      src={src}
      title={`${video.alt} ${video.index + 1}`}
      allow="autoplay; fullscreen"
      allowFullScreen
      loading="lazy"
      className={styles.video}
      tabIndex={-1}
    />
  );

  return video.caption ? (
    <figure className={styles.figure}>
      {iframe}
      <figcaption className={styles.caption}>{video.caption}</figcaption>
    </figure>
  ) : (
    iframe
  );
};

export default GalleryModalVideoYoutube;
